import Config from 'react-native-config';
import { Platform } from 'react-native';
import { getInstalledAppVersion } from '../native/AppVersion';

const packageJson = require('../../package.json') as { name?: string; version?: string };

/** Fallback when the native AppVersion module is unavailable (web, tests). */
const NATIVE_BUILD = {
  versionName: '1.0',
  versionCode: '1',
} as const;

export type AppInfo = {
  appName: string;
  version: string;
  buildNumber: string;
  apiVersion: string;
  environment: string;
  platform: string;
};

function apiVersionFromBaseUrl(baseUrl: string | undefined): string {
  if (!baseUrl) return 'Not configured';
  const match = baseUrl.match(/\/api\/(v\d+)\b/i);
  return match?.[1] ?? 'Unknown';
}

export function getAppInfo(): AppInfo {
  const installed = getInstalledAppVersion();
  return {
    appName: Config.APP_NAME?.trim() || packageJson.name || 'Faceark',
    version:
      installed?.versionName ||
      Config.APP_VERSION?.trim() ||
      NATIVE_BUILD.versionName ||
      packageJson.version ||
      '0.0.0',
    buildNumber: installed?.buildNumber || Config.APP_BUILD?.trim() || NATIVE_BUILD.versionCode,
    apiVersion: apiVersionFromBaseUrl(Config.API_BASE_URL),
    environment: Config.APP_ENV?.trim() || (__DEV__ ? 'development' : 'production'),
    platform: Platform.OS,
  };
}
